import request from '@/utils/request'

export function getCoupons(query) {
  return request({
    url: '/Coupon/getCoupons',
    method: 'get',
    params: query,
  })
}

export function getCouponCategory(query) {
  return request({
    url: '/Coupon/getCouponCategory',
    method: 'get',
    params: query,
  })
}

export function getCouponTag(query) {
  return request({
    url: '/Coupon/getCouponTag',
    method: 'get',
    params: query,
  })
}

export function saveCoupon(data) {
  return request({
    url: '/Coupon/saveCoupon',
    method: 'post',
    data,
  })
}

export function saveCouponCategory(data) {
  return request({
    url: '/Coupon/saveCouponCategory',
    method: 'post',
    data,
  })
}

export function saveCouponTag(data) {
  return request({
    url: '/Coupon/saveCouponTag',
    method: 'post',
    data,
  })
}

export function deleteCoupon(data) {
  return request({
    url: '/Coupon/deleteCoupon',
    method: 'post',
    data,
  })
}

export function deleteCouponTag(data) {
  return request({
    url: '/Coupon/deleteCouponTag',
    method: 'post',
    data,
  })
}

export function deleteCouponCategory(data) {
  return request({
    url: '/Coupon/deleteCouponCategory',
    method: 'post',
    data,
  })
}

export function getCouponCategoryOptions(query) {
  return request({
    url: '/Coupon/getCouponCategoryOptions',
    method: 'get',
    params: query,
  })
}

export function getCouponLoopCategoryOptions(query) {
  return request({
    url: '/Coupon/getCouponLoopCategoryOptions',
    method: 'get',
    params: query,
  })
}

export function saveDefaultCoupon(data) {
  return request({
    url: '/Coupon/saveDefaultCoupon',
    method: 'post',
    data,
  })
}

export function getDefaultCoupon(query) {
  return request({
    url: '/Coupon/getDefaultCoupon',
    method: 'get',
    params: query,
  })
}
